var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desempenho-cartaz-page"},[(_vm.erro)?_c('div',{staticClass:"desempenho-cartaz-erro"},[_vm._v(" "+_vm._s(_vm.erro)+" ")]):_c('CartazPreview',{attrs:{"dados":_vm.dadosCartaz}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }